"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Streaming_1 = __importDefault(require("./Streaming"));
exports.default = Streaming_1.default;
